import * as actionTypes from "../ActionTypes";

const initialState = {
  loading: false,
  coverImages: [],
  error: null,
};

export default function bulletinCoverImageReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SAVE_BULLETIN_COVERIMAGE_REQUEST:
    case actionTypes.UPDATE_BULLETIN_COVERIMAGE_REQUEST:
      case actionTypes.DELETE_BULLETIN_COVERIMAGE_REQUEST:

      return { ...state, loading: true, error: null };

    case actionTypes.SAVE_BULLETIN_COVERIMAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        coverImages: [...state.coverImages, action.payload],
      };

    case actionTypes.UPDATE_BULLETIN_COVERIMAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        coverImages: state.coverImages.map((img) =>
          img.bulletinObjId === action.payload.bulletinObjId
            ? { ...img, ...action.payload }
            : img
        ),
      };
      case actionTypes.DELETE_BULLETIN_COVERIMAGE_SUCCESS: {
        const updatedList = (state.bulletinCoverImages || []).filter(
          (img) =>
            !(
              img.bulletinObjId === action.payload.bulletinObjId &&
              img.bullitenimageObjId === action.payload.bullitenimageObjId
            )
        );
  
        return {
          ...state,
          loading: false,
          bulletinCoverImages: updatedList,
        };
      }
    case actionTypes.SAVE_BULLETIN_COVERIMAGE_FAILURE:
    case actionTypes.UPDATE_BULLETIN_COVERIMAGE_FAILURE:
      case actionTypes.DELETE_BULLETIN_COVERIMAGE_FAILURE:

      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
}
